module.exports = __webpack_public_path__ + "static/dynamo_header-c7f3d180c0f37508c988b3fa92ca07a8.png";